module.exports = __webpack_public_path__ + "img/cta_7.bdfb72bc.png";